import { Switch, Tooltip } from 'antd';
import NetworkRequestTables from './dimensionList';
import React, { useState, useMemo, useEffect } from 'react';
import { InvalidIntervalContainer, RCASwitch, RCATitle, RootContainer, TopBar } from './styled';
import { RCATables } from './rcaTables';
import { useSelector } from 'react-redux';
import { chartIntervalSelector } from '@src/store/trends/birdChart/selectors';
import moment from 'moment';
import { metricFilterSelector } from '@src/store/trends/base/selectors';
import { get } from 'lodash';
import { appMetricFilteringSelector, rcaFeatureSelector } from '@src/store/common/selectors';

export const AppAnalyseNetworkRequest: React.FC = () => {
  const rcaFeatureFlag = useSelector(rcaFeatureSelector);
  const sfFeatureFlag = useSelector(appMetricFilteringSelector);
  const [rcaMode, setRCAMode] = useState<boolean>(false);
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const modeText = rcaMode ? 'ON' : 'OFF';
  const interval = useSelector(chartIntervalSelector);
  const metricFilter = useSelector(metricFilterSelector);
  const isIntervalInvalid = useMemo(() => {
    return moment(interval.to).diff(moment(interval.from), 'hours') > 24;
  }, [interval]);

  const dimension = get(metricFilter, '[0].rule.dimension');
  const rcaEnabled = [
    'avg_page_load_time_distribution',
    'avg_screen_load_time_distribution',
    'avg_request_duration_distribution',
    'app_startup_time_distribution',
  ].includes(dimension);
  useEffect(() => {
    if (rcaEnabled) {
      setRCAMode(true);
    } else {
      setRCAMode(false);
    }
  }, [rcaEnabled]);

  const handleSwitchChange = (v: boolean) => {
    setRCAMode(v);
  };

  /** HP-4837: Only support query within 24 hours */
  if (isIntervalInvalid) {
    return (
      <InvalidIntervalContainer>
        Network Request is only supported for 24 hour range.
      </InvalidIntervalContainer>
    );
  }

  const openTooltip = () => {
    if (!rcaEnabled) {
      setTooltipOpen(true);
    }
  };

  const closeTooltip = () => {
    setTooltipOpen(false);
  };

  return (
    <RootContainer>
      {sfFeatureFlag && rcaFeatureFlag && (
        <TopBar>
          {rcaMode ? <RCATitle>Root Cause Hypothesis</RCATitle> : <div />}
          <Tooltip
            title="This mode is only available when using one of these metrics as a secondary filter: Avg App Startup Time, Avg Network Request Duration, Avg Screen Load Time, or Avg Page Load Time."
            placement="leftBottom"
            open={tooltipOpen}
          >
            <RCASwitch onMouseEnter={openTooltip} onMouseLeave={closeTooltip}>
              <Switch checked={rcaMode} onChange={handleSwitchChange} disabled={!rcaEnabled} />
              <div className="rca-mode-text">
                RCA Mode
                <div className="rca-mode-status-text">{modeText}</div>
              </div>
            </RCASwitch>
          </Tooltip>
        </TopBar>
      )}
      {sfFeatureFlag && rcaFeatureFlag && rcaMode ? <RCATables /> : <NetworkRequestTables />}
    </RootContainer>
  );
};
